export default {
    "rspCode": "000000",
    "rspInfo": "success",
    "rspReserved": null,
    "rspBody": {
        "list": [
            {
                "id": "AD",
                "code": "020",
                "zoneNumber": "+376",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "安道尔",
                "enameAbbr": "AND",
                "ename": "Andorra"
            },
            {
                "id": "AE",
                "code": "784",
                "zoneNumber": "+971",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "阿联酋",
                "enameAbbr": "ARE",
                "ename": "United Arab Emirates"
            },
            {
                "id": "AF",
                "code": "004",
                "zoneNumber": "+93",
                "highRiskFlag": "F",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "阿富汗",
                "enameAbbr": "AFG",
                "ename": "Afghanistan"
            },
            {
                "id": "AG",
                "code": "028",
                "zoneNumber": "+1268",
                "highRiskFlag": "L",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "安提瓜和巴布达",
                "enameAbbr": "ATG",
                "ename": "Antigua and Barbuda"
            },
            {
                "id": "AI",
                "code": "660",
                "zoneNumber": "+1264",
                "highRiskFlag": "L",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "安圭拉",
                "enameAbbr": "AIA",
                "ename": "Anguilla"
            },
            {
                "id": "AL",
                "code": "008",
                "zoneNumber": "+355",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "阿尔巴尼亚",
                "enameAbbr": "ALB",
                "ename": "Albania"
            },
            {
                "id": "AM",
                "code": "051",
                "zoneNumber": "+374",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "亚美尼亚",
                "enameAbbr": "ARM",
                "ename": "Armenia"
            },
            {
                "id": "AO",
                "code": "024",
                "zoneNumber": "+244",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "安哥拉",
                "enameAbbr": "AGO",
                "ename": "Angola"
            },
            {
                "id": "AR",
                "code": "032",
                "zoneNumber": "+54",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "阿根廷",
                "enameAbbr": "ARG",
                "ename": "Argentina"
            },
            {
                "id": "AT",
                "code": "040",
                "zoneNumber": "+43",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "奥地利",
                "enameAbbr": "AUT",
                "ename": "Austria"
            },
            {
                "id": "AU",
                "code": "036",
                "zoneNumber": "+61",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "澳大利亚",
                "enameAbbr": "AUS",
                "ename": "Australia"
            },
            {
                "id": "AW",
                "code": "533",
                "zoneNumber": "+297",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "阿鲁巴",
                "enameAbbr": "ABW",
                "ename": "Aruba"
            },
            {
                "id": "AZ",
                "code": "031",
                "zoneNumber": "+994",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "阿塞拜疆",
                "enameAbbr": "AZE",
                "ename": "Azerbaijan"
            },
            {
                "id": "BA",
                "code": "070",
                "zoneNumber": "+387",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "波黑",
                "enameAbbr": "BIH",
                "ename": "Bosnia and Herzegovina"
            },
            {
                "id": "BB",
                "code": "052",
                "zoneNumber": "+1246",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "巴巴多斯",
                "enameAbbr": "BRB",
                "ename": "Barbados"
            },
            {
                "id": "BD",
                "code": "050",
                "zoneNumber": "+880",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "孟加拉国",
                "enameAbbr": "BGD",
                "ename": "Bangladesh"
            },
            {
                "id": "BE",
                "code": "056",
                "zoneNumber": "+32",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "比利时",
                "enameAbbr": "BEL",
                "ename": "Belgium"
            },
            {
                "id": "BF",
                "code": "854",
                "zoneNumber": "+226",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "布基纳法索",
                "enameAbbr": "BFA",
                "ename": "Burkina Faso"
            },
            {
                "id": "BG",
                "code": "100",
                "zoneNumber": "+359",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "保加利亚",
                "enameAbbr": "BGR",
                "ename": "Bulgaria"
            },
            {
                "id": "BH",
                "code": "048",
                "zoneNumber": "+973",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "巴林",
                "enameAbbr": "BHR",
                "ename": "Bahrain"
            },
            {
                "id": "BI",
                "code": "108",
                "zoneNumber": "+257",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "布隆迪",
                "enameAbbr": "BDI",
                "ename": "Burundi"
            },
            {
                "id": "BJ",
                "code": "204",
                "zoneNumber": "+229",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "贝宁",
                "enameAbbr": "BEN",
                "ename": "Benin"
            },
            {
                "id": "BM",
                "code": "060",
                "zoneNumber": "+1441",
                "highRiskFlag": "N",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "百慕大",
                "enameAbbr": "BMU",
                "ename": "Bermuda"
            },
            {
                "id": "BN",
                "code": "096",
                "zoneNumber": "+673",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "文莱",
                "enameAbbr": "BRN",
                "ename": "Brunei"
            },
            {
                "id": "BO",
                "code": "068",
                "zoneNumber": "+591",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "玻利维亚",
                "enameAbbr": "BOL",
                "ename": "Bolivia"
            },
            {
                "id": "BR",
                "code": "076",
                "zoneNumber": "+55",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "巴西",
                "enameAbbr": "BRA",
                "ename": "Brazil"
            },
            {
                "id": "BS",
                "code": "044",
                "zoneNumber": "+1242",
                "highRiskFlag": "L",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "巴哈马",
                "enameAbbr": "BHS",
                "ename": "Bahamas"
            },
            {
                "id": "BT",
                "code": "064",
                "zoneNumber": "+975",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "不丹",
                "enameAbbr": "BTN",
                "ename": "Bhutan"
            },
            {
                "id": "BW",
                "code": "072",
                "zoneNumber": "+267",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "博茨瓦纳",
                "enameAbbr": "BWA",
                "ename": "Botswana"
            },
            {
                "id": "BY",
                "code": "112",
                "zoneNumber": "+375",
                "highRiskFlag": "F",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "白俄罗斯",
                "enameAbbr": "BLR",
                "ename": "Belarus"
            },
            {
                "id": "BZ",
                "code": "084",
                "zoneNumber": "+501",
                "highRiskFlag": "L",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "伯利兹",
                "enameAbbr": "BLZ",
                "ename": "Belize"
            },
            {
                "id": "CA",
                "code": "124",
                "zoneNumber": "+1",
                "highRiskFlag": "N",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "加拿大",
                "enameAbbr": "CAN",
                "ename": "Canada"
            },
            {
                "id": "CD",
                "code": "180",
                "zoneNumber": "+242",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "刚果民主共和国",
                "enameAbbr": "COD",
                "ename": "Democractic Republic of Congo"
            },
            {
                "id": "CF",
                "code": "140",
                "zoneNumber": "+236",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "中非共和国",
                "enameAbbr": "CAF",
                "ename": "Central African Republic"
            },
            {
                "id": "CH",
                "code": "756",
                "zoneNumber": "+41",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "瑞士",
                "enameAbbr": "CHE",
                "ename": "Switzerland"
            },
            {
                "id": "CK",
                "code": "184",
                "zoneNumber": "+682",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "库克群岛",
                "enameAbbr": "COK",
                "ename": "Cook Islands"
            },
            {
                "id": "CL",
                "code": "152",
                "zoneNumber": "+56",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "智利",
                "enameAbbr": "CHL",
                "ename": "Chile"
            },
            {
                "id": "CM",
                "code": "120",
                "zoneNumber": "+237",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "喀麦隆",
                "enameAbbr": "CMR",
                "ename": "Cameroon"
            },
            {
                "id": "CN",
                "code": "156",
                "zoneNumber": "+86",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "中国",
                "enameAbbr": "CHN",
                "ename": "China"
            },
            {
                "id": "CO",
                "code": "170",
                "zoneNumber": "+57",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "哥伦比亚",
                "enameAbbr": "COL",
                "ename": "Colombia"
            },
            {
                "id": "CR",
                "code": "188",
                "zoneNumber": "+506",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "哥斯达黎加",
                "enameAbbr": "CRI",
                "ename": "Costa Rica"
            },
            {
                "id": "CU",
                "code": "192",
                "zoneNumber": "+53",
                "highRiskFlag": "F",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "古巴",
                "enameAbbr": "CUB",
                "ename": "Cuba"
            },
            {
                "id": "CV",
                "code": "132",
                "zoneNumber": "+238",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "佛得角",
                "enameAbbr": "CPV",
                "ename": "Cape Verde"
            },
            {
                "id": "CY",
                "code": "196",
                "zoneNumber": "+357",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "塞浦路斯",
                "enameAbbr": "CYP",
                "ename": "Cyprus"
            },
            {
                "id": "CZ",
                "code": "203",
                "zoneNumber": "+420",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "捷克",
                "enameAbbr": "CZE",
                "ename": "Czech Republic"
            },
            {
                "id": "DE",
                "code": "276",
                "zoneNumber": "+49",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "德国",
                "enameAbbr": "DEU",
                "ename": "Germany"
            },
            {
                "id": "DJ",
                "code": "262",
                "zoneNumber": "+253",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "吉布提",
                "enameAbbr": "DJI",
                "ename": "Djibouti"
            },
            {
                "id": "DK",
                "code": "208",
                "zoneNumber": "+45",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "丹麦",
                "enameAbbr": "DNK",
                "ename": "Denmark"
            },
            {
                "id": "DM",
                "code": "212",
                "zoneNumber": "+1767",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "多米尼克",
                "enameAbbr": "DMA",
                "ename": "Dominica"
            },
            {
                "id": "DO",
                "code": "214",
                "zoneNumber": "+1809",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "多米尼加",
                "enameAbbr": "DOM",
                "ename": "Dominican Republic"
            },
            {
                "id": "DZ",
                "code": "012",
                "zoneNumber": "+213",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "阿尔及利亚",
                "enameAbbr": "DZA",
                "ename": "Algeria"
            },
            {
                "id": "EC",
                "code": "218",
                "zoneNumber": "+593",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "厄瓜多尔",
                "enameAbbr": "ECU",
                "ename": "Ecuador"
            },
            {
                "id": "EE",
                "code": "233",
                "zoneNumber": "+372",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "爱沙尼亚",
                "enameAbbr": "EST",
                "ename": "Estonia"
            },
            {
                "id": "EG",
                "code": "818",
                "zoneNumber": "+20",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "埃及",
                "enameAbbr": "EGY",
                "ename": "Egypt"
            },
            {
                "id": "ES",
                "code": "724",
                "zoneNumber": "+34",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "西班牙",
                "enameAbbr": "ESP",
                "ename": "Spain"
            },
            {
                "id": "ET",
                "code": "231",
                "zoneNumber": "+251",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "埃塞俄比亚",
                "enameAbbr": "ETH",
                "ename": "Ethiopia"
            },
            {
                "id": "FI",
                "code": "246",
                "zoneNumber": "+358",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "芬兰",
                "enameAbbr": "FIN",
                "ename": "Finland"
            },
            {
                "id": "FJ",
                "code": "242",
                "zoneNumber": "+679",
                "highRiskFlag": "L",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "斐济",
                "enameAbbr": "FJI",
                "ename": "Fiji"
            },
            {
                "id": "FR",
                "code": "250",
                "zoneNumber": "+33",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "法国",
                "enameAbbr": "FRA",
                "ename": "France"
            },
            {
                "id": "GA",
                "code": "266",
                "zoneNumber": "+241",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "加蓬",
                "enameAbbr": "GAB",
                "ename": "Gabon"
            },
            {
                "id": "GB",
                "code": "826",
                "zoneNumber": "+44",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "英国",
                "enameAbbr": "GBR",
                "ename": "United Kingdom"
            },
            {
                "id": "GD",
                "code": "308",
                "zoneNumber": "+1473",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "格林纳达",
                "enameAbbr": "GRD",
                "ename": "Grenada"
            },
            {
                "id": "GE",
                "code": "268",
                "zoneNumber": "+995",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "格鲁吉亚",
                "enameAbbr": "GEO",
                "ename": "Georgia"
            },
            {
                "id": "GF",
                "code": "254",
                "zoneNumber": "+594",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "法属圭亚那",
                "enameAbbr": "GUF",
                "ename": "French Guiana"
            },
            {
                "id": "GH",
                "code": "288",
                "zoneNumber": "+233",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "加纳",
                "enameAbbr": "GHA",
                "ename": "Ghana"
            },
            {
                "id": "GI",
                "code": "292",
                "zoneNumber": "+350",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "直布罗陀",
                "enameAbbr": "GIB",
                "ename": "Gibraltar"
            },
            {
                "id": "GL",
                "code": "304",
                "zoneNumber": "+299",
                "highRiskFlag": "N",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "格陵兰",
                "enameAbbr": "GRL",
                "ename": "Greenland"
            },
            {
                "id": "GM",
                "code": "270",
                "zoneNumber": "+220",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "冈比亚",
                "enameAbbr": "GMB",
                "ename": "Gambia"
            },
            {
                "id": "GR",
                "code": "300",
                "zoneNumber": "+30",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "希腊",
                "enameAbbr": "GRC",
                "ename": "Greece"
            },
            {
                "id": "GT",
                "code": "320",
                "zoneNumber": "+502",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "危地马拉",
                "enameAbbr": "GTM",
                "ename": "Guatemala"
            },
            {
                "id": "GW",
                "code": "624",
                "zoneNumber": "+245",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "几内亚比绍",
                "enameAbbr": "GNB",
                "ename": "Guinea-Bissau"
            },
            {
                "id": "GY",
                "code": "328",
                "zoneNumber": "+592",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "圭亚那",
                "enameAbbr": "GUY",
                "ename": "Guyana"
            },
            {
                "id": "HK",
                "code": "344",
                "zoneNumber": "+852",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "中国香港",
                "enameAbbr": "HKG",
                "ename": "Hong Kong SAR"
            },
            {
                "id": "HN",
                "code": "340",
                "zoneNumber": "+504",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "洪都拉斯",
                "enameAbbr": "HND",
                "ename": "Honduras"
            },
            {
                "id": "HR",
                "code": "191",
                "zoneNumber": "+385",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "克罗地亚",
                "enameAbbr": "HRV",
                "ename": "Croatia"
            },
            {
                "id": "HT",
                "code": "332",
                "zoneNumber": "+509",
                "highRiskFlag": "L",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "海地",
                "enameAbbr": "HTI",
                "ename": "Haiti"
            },
            {
                "id": "HU",
                "code": "348",
                "zoneNumber": "+36",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "匈牙利",
                "enameAbbr": "HUN",
                "ename": "Hungary"
            },
            {
                "id": "ID",
                "code": "360",
                "zoneNumber": "+62",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "印度尼西亚",
                "enameAbbr": "IDN",
                "ename": "Indonesia"
            },
            {
                "id": "IE",
                "code": "372",
                "zoneNumber": "+353",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "爱尔兰",
                "enameAbbr": "IRL",
                "ename": "Ireland"
            },
            {
                "id": "IL",
                "code": "376",
                "zoneNumber": "+972",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "以色列",
                "enameAbbr": "ISR",
                "ename": "Israel"
            },
            {
                "id": "IN",
                "code": "356",
                "zoneNumber": "+91",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "印度",
                "enameAbbr": "IND",
                "ename": "India"
            },
            {
                "id": "IQ",
                "code": "368",
                "zoneNumber": "+964",
                "highRiskFlag": "L",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "伊拉克",
                "enameAbbr": "IRQ",
                "ename": "Iraq"
            },
            {
                "id": "IR",
                "code": "364",
                "zoneNumber": "+98",
                "highRiskFlag": "F",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "伊朗",
                "enameAbbr": "IRN",
                "ename": "Iran"
            },
            {
                "id": "IS",
                "code": "352",
                "zoneNumber": "+354",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "冰岛",
                "enameAbbr": "ISL",
                "ename": "Iceland"
            },
            {
                "id": "IT",
                "code": "380",
                "zoneNumber": "+39",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "意大利",
                "enameAbbr": "ITA",
                "ename": "Italy"
            },
            {
                "id": "JM",
                "code": "388",
                "zoneNumber": "+1876",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "牙买加",
                "enameAbbr": "JAM",
                "ename": "Jamaica"
            },
            {
                "id": "JO",
                "code": "400",
                "zoneNumber": "+962",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "约旦",
                "enameAbbr": "JOR",
                "ename": "Jordan"
            },
            {
                "id": "JP",
                "code": "392",
                "zoneNumber": "+81",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "日本",
                "enameAbbr": "JPN",
                "ename": "Japan"
            },
            {
                "id": "KE",
                "code": "404",
                "zoneNumber": "+254",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "肯尼亚",
                "enameAbbr": "KEN",
                "ename": "Kenya"
            },
            {
                "id": "KG",
                "code": "417",
                "zoneNumber": "+996",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "吉尔吉斯斯坦",
                "enameAbbr": "KGZ",
                "ename": "Kyrgyzstan"
            },
            {
                "id": "KH",
                "code": "116",
                "zoneNumber": "+855",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "柬埔寨",
                "enameAbbr": "KHM",
                "ename": "Cambodia"
            },
            {
                "id": "KI",
                "code": "296",
                "zoneNumber": "+686",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "基里巴斯",
                "enameAbbr": "KIR",
                "ename": "Kiribati"
            },
            {
                "id": "KM",
                "code": "174",
                "zoneNumber": "+269",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "科摩罗",
                "enameAbbr": "COM",
                "ename": "Comoros"
            },
            {
                "id": "KN",
                "code": "659",
                "zoneNumber": "+1869",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "圣基茨和尼维斯",
                "enameAbbr": "KNA",
                "ename": "Saint Kitts and Nevis"
            },
            {
                "id": "KP",
                "code": "408",
                "zoneNumber": "+850",
                "highRiskFlag": "F",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "朝鲜",
                "enameAbbr": "PRK",
                "ename": "North Korea"
            },
            {
                "id": "KR",
                "code": "410",
                "zoneNumber": "+82",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "韩国",
                "enameAbbr": "KOR",
                "ename": "Korea, Republic of Korea"
            },
            {
                "id": "KW",
                "code": "414",
                "zoneNumber": "+965",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "科威特",
                "enameAbbr": "KWT",
                "ename": "Kuwait"
            },
            {
                "id": "KY",
                "code": "136",
                "zoneNumber": "+1345",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "开曼群岛",
                "enameAbbr": "CYM",
                "ename": "Cayman Islands"
            },
            {
                "id": "KZ",
                "code": "398",
                "zoneNumber": "+7",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "哈萨克斯坦",
                "enameAbbr": "KAZ",
                "ename": "Kazakhstan"
            },
            {
                "id": "LA",
                "code": "418",
                "zoneNumber": "+856",
                "highRiskFlag": "L",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "老挝",
                "enameAbbr": "LAO",
                "ename": "Laos"
            },
            {
                "id": "LB",
                "code": "422",
                "zoneNumber": "+961",
                "highRiskFlag": "L",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "黎巴嫩",
                "enameAbbr": "LBN",
                "ename": "Lebanon"
            },
            {
                "id": "LC",
                "code": "662",
                "zoneNumber": "+1758",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "圣卢西亚",
                "enameAbbr": "LCA",
                "ename": "Saint Lucia"
            },
            {
                "id": "LI",
                "code": "438",
                "zoneNumber": "+423",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "列支敦士登",
                "enameAbbr": "LIE",
                "ename": "Liechtenstein"
            },
            {
                "id": "LK",
                "code": "144",
                "zoneNumber": "+94",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "斯里兰卡",
                "enameAbbr": "LKA",
                "ename": "Sri Lanka"
            },
            {
                "id": "LR",
                "code": "430",
                "zoneNumber": "+231",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "利比里亚",
                "enameAbbr": "LBR",
                "ename": "Liberia"
            },
            {
                "id": "LS",
                "code": "426",
                "zoneNumber": "+266",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "莱索托",
                "enameAbbr": "LSO",
                "ename": "Lesotho"
            },
            {
                "id": "LT",
                "code": "440",
                "zoneNumber": "+370",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "立陶宛",
                "enameAbbr": "LTU",
                "ename": "Lithuania"
            },
            {
                "id": "LU",
                "code": "442",
                "zoneNumber": "+352",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "卢森堡",
                "enameAbbr": "LUX",
                "ename": "Luxembourg"
            },
            {
                "id": "LV",
                "code": "428",
                "zoneNumber": "+371",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "拉脱维亚",
                "enameAbbr": "LVA",
                "ename": "Latvia"
            },
            {
                "id": "LY",
                "code": "434",
                "zoneNumber": "+218",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "利比亚",
                "enameAbbr": "LBY",
                "ename": "Libya"
            },
            {
                "id": "MA",
                "code": "504",
                "zoneNumber": "+212",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "摩洛哥",
                "enameAbbr": "MAR",
                "ename": "Morocco"
            },
            {
                "id": "MC",
                "code": "492",
                "zoneNumber": "+377",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "摩纳哥",
                "enameAbbr": "MCO",
                "ename": "Monaco"
            },
            {
                "id": "MD",
                "code": "498",
                "zoneNumber": "+373",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "摩尔多瓦",
                "enameAbbr": "MDA",
                "ename": "Moldova"
            },
            {
                "id": "ME",
                "code": "499",
                "zoneNumber": "+382",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "黑山",
                "enameAbbr": "MNE",
                "ename": "Montenegro"
            },
            {
                "id": "MG",
                "code": "450",
                "zoneNumber": "+261",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "马达加斯加",
                "enameAbbr": "MDG",
                "ename": "Madagascar"
            },
            {
                "id": "MH",
                "code": "584",
                "zoneNumber": "+692",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "马绍尔群岛",
                "enameAbbr": "MHL",
                "ename": "Marshall Islands"
            },
            {
                "id": "MK",
                "code": "807",
                "zoneNumber": "+389",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "北马其顿",
                "enameAbbr": "MKD",
                "ename": "The Republic of North Macedonia"
            },
            {
                "id": "ML",
                "code": "466",
                "zoneNumber": "+223",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "马里",
                "enameAbbr": "MLI",
                "ename": "Mali"
            },
            {
                "id": "MM",
                "code": "104",
                "zoneNumber": "+95",
                "highRiskFlag": "F",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "缅甸",
                "enameAbbr": "MMR",
                "ename": "Myanmar (Burma)"
            },
            {
                "id": "MN",
                "code": "496",
                "zoneNumber": "+976",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "蒙古",
                "enameAbbr": "MNG",
                "ename": "Mongolia"
            },
            {
                "id": "MO",
                "code": "446",
                "zoneNumber": "+853",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "中国澳门",
                "enameAbbr": "MAC",
                "ename": "Macau SAR"
            },
            {
                "id": "MR",
                "code": "478",
                "zoneNumber": "+222",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "毛里塔尼亚",
                "enameAbbr": "MRT",
                "ename": "Mauritania"
            },
            {
                "id": "MT",
                "code": "470",
                "zoneNumber": "+356",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "马耳他",
                "enameAbbr": "MLT",
                "ename": "Malta"
            },
            {
                "id": "MU",
                "code": "480",
                "zoneNumber": "+230",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "毛里求斯",
                "enameAbbr": "MUS",
                "ename": "Mauritius"
            },
            {
                "id": "MV",
                "code": "462",
                "zoneNumber": "+960",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "马尔代夫",
                "enameAbbr": "MDV",
                "ename": "Maldives"
            },
            {
                "id": "MW",
                "code": "454",
                "zoneNumber": "+265",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "马拉维",
                "enameAbbr": "MWI",
                "ename": "Malawi"
            },
            {
                "id": "MX",
                "code": "484",
                "zoneNumber": "+52",
                "highRiskFlag": "N",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "墨西哥",
                "enameAbbr": "MEX",
                "ename": "Mexico"
            },
            {
                "id": "MY",
                "code": "458",
                "zoneNumber": "+60",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "马来西亚",
                "enameAbbr": "MYS",
                "ename": "Malaysia"
            },
            {
                "id": "MZ",
                "code": "508",
                "zoneNumber": "+258",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "莫桑比克",
                "enameAbbr": "MOZ",
                "ename": "Mozambique"
            },
            {
                "id": "NA",
                "code": "516",
                "zoneNumber": "+264",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "纳米比亚",
                "enameAbbr": "NAM",
                "ename": "Namibia"
            },
            {
                "id": "NE",
                "code": "562",
                "zoneNumber": "+227",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "尼日尔",
                "enameAbbr": "NER",
                "ename": "Niger"
            },
            {
                "id": "NG",
                "code": "566",
                "zoneNumber": "+234",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "尼日利亚",
                "enameAbbr": "NGA",
                "ename": "Nigeria"
            },
            {
                "id": "NI",
                "code": "558",
                "zoneNumber": "+505",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "尼加拉瓜",
                "enameAbbr": "NIC",
                "ename": "Nicaragua"
            },
            {
                "id": "NL",
                "code": "528",
                "zoneNumber": "+31",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "荷兰",
                "enameAbbr": "NLD",
                "ename": "Netherlands"
            },
            {
                "id": "NO",
                "code": "578",
                "zoneNumber": "+47",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "挪威",
                "enameAbbr": "NOR",
                "ename": "Norway"
            },
            {
                "id": "NP",
                "code": "524",
                "zoneNumber": "+977",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "尼泊尔",
                "enameAbbr": "NPL",
                "ename": "Nepal"
            },
            {
                "id": "NR",
                "code": "520",
                "zoneNumber": "+674",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "瑙鲁",
                "enameAbbr": "NRU",
                "ename": "Nauru"
            },
            {
                "id": "NU",
                "code": "570",
                "zoneNumber": "+683",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "纽埃",
                "enameAbbr": "NIU",
                "ename": "Niue"
            },
            {
                "id": "NZ",
                "code": "554",
                "zoneNumber": "+64",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "新西兰",
                "enameAbbr": "NZL",
                "ename": "New Zealand"
            },
            {
                "id": "OM",
                "code": "512",
                "zoneNumber": "+968",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "阿曼",
                "enameAbbr": "OMN",
                "ename": "Oman"
            },
            {
                "id": "PA",
                "code": "591",
                "zoneNumber": "+507",
                "highRiskFlag": "L",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "巴拿马",
                "enameAbbr": "PAN",
                "ename": "Panama"
            },
            {
                "id": "PE",
                "code": "604",
                "zoneNumber": "+51",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "秘鲁",
                "enameAbbr": "PER",
                "ename": "Peru"
            },
            {
                "id": "PF",
                "code": "258",
                "zoneNumber": "+681",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "波利尼西亚",
                "enameAbbr": "PYF",
                "ename": "Polynesia"
            },
            {
                "id": "PG",
                "code": "598",
                "zoneNumber": "+675",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "巴布亚新几内亚",
                "enameAbbr": "PNG",
                "ename": "Papua New Guinea"
            },
            {
                "id": "PH",
                "code": "608",
                "zoneNumber": "+63",
                "highRiskFlag": "L",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "菲律宾",
                "enameAbbr": "PHL",
                "ename": "Philippines"
            },
            {
                "id": "PK",
                "code": "586",
                "zoneNumber": "+92",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "巴基斯坦",
                "enameAbbr": "PAK",
                "ename": "Pakistan"
            },
            {
                "id": "PL",
                "code": "616",
                "zoneNumber": "+48",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "波兰",
                "enameAbbr": "POL",
                "ename": "Poland"
            },
            {
                "id": "PR",
                "code": "630",
                "zoneNumber": "+1",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "波多黎各",
                "enameAbbr": "PRI",
                "ename": "Puerto Rico"
            },
            {
                "id": "PS",
                "code": "275",
                "zoneNumber": "+930",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "巴勒斯坦",
                "enameAbbr": "PSE",
                "ename": "Palestine"
            },
            {
                "id": "PT",
                "code": "620",
                "zoneNumber": "+351",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "葡萄牙",
                "enameAbbr": "PRT",
                "ename": "Portugal"
            },
            {
                "id": "PW",
                "code": "585",
                "zoneNumber": "+680",
                "highRiskFlag": "L",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "帕劳",
                "enameAbbr": "PLW",
                "ename": "Palau"
            },
            {
                "id": "PY",
                "code": "600",
                "zoneNumber": "+595",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "巴拉圭",
                "enameAbbr": "PRY",
                "ename": "Paraguay"
            },
            {
                "id": "QA",
                "code": "634",
                "zoneNumber": "+974",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "卡塔尔",
                "enameAbbr": "QAT",
                "ename": "Qatar"
            },
            {
                "id": "RO",
                "code": "642",
                "zoneNumber": "+40",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "罗马尼亚",
                "enameAbbr": "ROU",
                "ename": "Romania"
            },
            {
                "id": "RS",
                "code": "688",
                "zoneNumber": "+381",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "塞尔维亚",
                "enameAbbr": "SRB",
                "ename": "Serbia"
            },
            {
                "id": "RU",
                "code": "643",
                "zoneNumber": "+7",
                "highRiskFlag": "F",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "俄罗斯",
                "enameAbbr": "RUS",
                "ename": "Russian Federation"
            },
            {
                "id": "RW",
                "code": "646",
                "zoneNumber": "+250",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "卢旺达",
                "enameAbbr": "RWA",
                "ename": "Rwanda"
            },
            {
                "id": "SA",
                "code": "682",
                "zoneNumber": "+966",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "沙特阿拉伯",
                "enameAbbr": "SAU",
                "ename": "Saudi Arabia"
            },
            {
                "id": "SB",
                "code": "090",
                "zoneNumber": "+677",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "所罗门群岛",
                "enameAbbr": "SLB",
                "ename": "Solomon Islands"
            },
            {
                "id": "SC",
                "code": "690",
                "zoneNumber": "+248",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "塞舌尔",
                "enameAbbr": "SYC",
                "ename": "Seychelles"
            },
            {
                "id": "SD",
                "code": "736",
                "zoneNumber": "+249",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "苏丹",
                "enameAbbr": "SDN",
                "ename": "Sudan"
            },
            {
                "id": "SE",
                "code": "752",
                "zoneNumber": "+46",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "瑞典",
                "enameAbbr": "SWE",
                "ename": "Sweden"
            },
            {
                "id": "SG",
                "code": "702",
                "zoneNumber": "+65",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "新加坡",
                "enameAbbr": "SGP",
                "ename": "Singapore"
            },
            {
                "id": "SI",
                "code": "705",
                "zoneNumber": "+386",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "斯洛文尼亚",
                "enameAbbr": "SVN",
                "ename": "Slovenia"
            },
            {
                "id": "SK",
                "code": "703",
                "zoneNumber": "+421",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "斯洛伐克",
                "enameAbbr": "SVK",
                "ename": "Slovakia"
            },
            {
                "id": "SL",
                "code": "694",
                "zoneNumber": "+232",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "塞拉利昂",
                "enameAbbr": "SLE",
                "ename": "Sierra Leone"
            },
            {
                "id": "SM",
                "code": "674",
                "zoneNumber": "+378",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "圣马力诺",
                "enameAbbr": "SMR",
                "ename": "San Marino"
            },
            {
                "id": "SN",
                "code": "686",
                "zoneNumber": "+221",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "塞内加尔",
                "enameAbbr": "SEN",
                "ename": "Senegal"
            },
            {
                "id": "SO",
                "code": "706",
                "zoneNumber": "+252",
                "highRiskFlag": "F",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "索马里",
                "enameAbbr": "SOM",
                "ename": "Somalia"
            },
            {
                "id": "SR",
                "code": "740",
                "zoneNumber": "+597",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "苏里南",
                "enameAbbr": "SUR",
                "ename": "Suriname"
            },
            {
                "id": "SS",
                "code": "728",
                "zoneNumber": "+211",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "南苏丹",
                "enameAbbr": "SSD",
                "ename": "South Sudan"
            },
            {
                "id": "ST",
                "code": "678",
                "zoneNumber": "+239",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "圣多美和普林西比",
                "enameAbbr": "STP",
                "ename": "Sao Tome and Principe"
            },
            {
                "id": "SV",
                "code": "222",
                "zoneNumber": "+503",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "萨尔瓦多",
                "enameAbbr": "SLV",
                "ename": "El Salvador"
            },
            {
                "id": "SY",
                "code": "760",
                "zoneNumber": "+963",
                "highRiskFlag": "F",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "叙利亚",
                "enameAbbr": "SYR",
                "ename": "Syria"
            },
            {
                "id": "SZ",
                "code": "748",
                "zoneNumber": "+268",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "斯威士兰",
                "enameAbbr": "SWZ",
                "ename": "Swaziland"
            },
            {
                "id": "TD",
                "code": "148",
                "zoneNumber": "+235",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "乍得",
                "enameAbbr": "TCD",
                "ename": "Chad"
            },
            {
                "id": "TG",
                "code": "768",
                "zoneNumber": "+228",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "多哥",
                "enameAbbr": "TGO",
                "ename": "Togo"
            },
            {
                "id": "TH",
                "code": "764",
                "zoneNumber": "+66",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "泰国",
                "enameAbbr": "THA",
                "ename": "Thailand"
            },
            {
                "id": "TJ",
                "code": "762",
                "zoneNumber": "+992",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "塔吉克斯坦",
                "enameAbbr": "TJK",
                "ename": "Tajikistan"
            },
            {
                "id": "TL",
                "code": "626",
                "zoneNumber": "+670",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "东帝汶",
                "enameAbbr": "TLS",
                "ename": "Timor-Leste"
            },
            {
                "id": "TM",
                "code": "795",
                "zoneNumber": "+993",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "土库曼斯坦",
                "enameAbbr": "TKM",
                "ename": "Turkmenistan"
            },
            {
                "id": "TN",
                "code": "788",
                "zoneNumber": "+216",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "突尼斯",
                "enameAbbr": "TUN",
                "ename": "Tunisia"
            },
            {
                "id": "TO",
                "code": "776",
                "zoneNumber": "+676",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "汤加",
                "enameAbbr": "TON",
                "ename": "Tonga"
            },
            {
                "id": "TR",
                "code": "792",
                "zoneNumber": "+90",
                "highRiskFlag": "L",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "土耳其",
                "enameAbbr": "TUR",
                "ename": "Turkey"
            },
            {
                "id": "TT",
                "code": "780",
                "zoneNumber": "+1868",
                "highRiskFlag": "L",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "特立尼达和多巴哥",
                "enameAbbr": "TTO",
                "ename": "Republic of Trinidad and Tobago"
            },
            {
                "id": "TV",
                "code": "798",
                "zoneNumber": "+688",
                "highRiskFlag": "N",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "图瓦卢",
                "enameAbbr": "TUV",
                "ename": "Tuvalu"
            },
            {
                "id": "TW",
                "code": "158",
                "zoneNumber": "+886",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "中国台湾",
                "enameAbbr": "TWN",
                "ename": "Taiwan, China"
            },
            {
                "id": "TZ",
                "code": "834",
                "zoneNumber": "+255",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "坦桑尼亚",
                "enameAbbr": "TZA",
                "ename": "United Republic of Tanzania"
            },
            {
                "id": "UA",
                "code": "804",
                "zoneNumber": "+380",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "乌克兰",
                "enameAbbr": "UKR",
                "ename": "Ukraine"
            },
            {
                "id": "UG",
                "code": "800",
                "zoneNumber": "+256",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "乌干达",
                "enameAbbr": "UGA",
                "ename": "Uganda"
            },
            {
                "id": "US",
                "code": "840",
                "zoneNumber": "+1",
                "highRiskFlag": "N",
                "ccontinent": "北美洲",
                "econtinent": "NA",
                "cname": "美国",
                "enameAbbr": "USA",
                "ename": "United States of America"
            },
            {
                "id": "UY",
                "code": "858",
                "zoneNumber": "+598",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "乌拉圭",
                "enameAbbr": "URY",
                "ename": "Uruguay"
            },
            {
                "id": "UZ",
                "code": "860",
                "zoneNumber": "+998",
                "highRiskFlag": "N",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "乌兹别克斯坦",
                "enameAbbr": "UZB",
                "ename": "Uzbekistan"
            },
            {
                "id": "VA",
                "code": "336",
                "zoneNumber": "+14397",
                "highRiskFlag": "N",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "梵蒂冈",
                "enameAbbr": "VAT",
                "ename": "Vatican"
            },
            {
                "id": "VC",
                "code": "670",
                "zoneNumber": "+1784",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "圣文森特和格林纳丁斯",
                "enameAbbr": "VCT",
                "ename": "Saint Vincent and The Grenad"
            },
            {
                "id": "VE",
                "code": "862",
                "zoneNumber": "+58",
                "highRiskFlag": "F",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "委内瑞拉",
                "enameAbbr": "VEN",
                "ename": "Venezuela"
            },
            {
                "id": "VG",
                "code": "092",
                "zoneNumber": "+1284",
                "highRiskFlag": "N",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "英属维尔京群岛",
                "enameAbbr": "VGB",
                "ename": "Virgin Islands, British"
            },
            {
                "id": "VI",
                "code": "850",
                "zoneNumber": "+1340",
                "highRiskFlag": "L",
                "ccontinent": "南美洲",
                "econtinent": "SA",
                "cname": "美属维尔京群岛",
                "enameAbbr": "VIR",
                "ename": "Virgin Islands, U.S."
            },
            {
                "id": "VN",
                "code": "704",
                "zoneNumber": "+84",
                "highRiskFlag": "L",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "越南",
                "enameAbbr": "VNM",
                "ename": "Vietnam"
            },
            {
                "id": "VU",
                "code": "548",
                "zoneNumber": "+678",
                "highRiskFlag": "L",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "瓦努阿图",
                "enameAbbr": "VUT",
                "ename": "Vanuatu"
            },
            {
                "id": "WS",
                "code": "882",
                "zoneNumber": "+1684",
                "highRiskFlag": "L",
                "ccontinent": "大洋洲",
                "econtinent": "OA",
                "cname": "萨摩亚",
                "enameAbbr": "WSM",
                "ename": "Samoa"
            },
            {
                "id": "XK",
                "code": null,
                "zoneNumber": "+383",
                "highRiskFlag": "L",
                "ccontinent": "欧洲",
                "econtinent": "EU",
                "cname": "科索沃",
                "enameAbbr": "XKX",
                "ename": "Kosovo"
            },
            {
                "id": "YE",
                "code": "887",
                "zoneNumber": "+967",
                "highRiskFlag": "F",
                "ccontinent": "亚洲",
                "econtinent": "AS",
                "cname": "也门",
                "enameAbbr": "YEM",
                "ename": "Yemen"
            },
            {
                "id": "ZA",
                "code": "710",
                "zoneNumber": "+27",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "南非",
                "enameAbbr": "ZAF",
                "ename": "South Africa"
            },
            {
                "id": "ZM",
                "code": "894",
                "zoneNumber": "+260",
                "highRiskFlag": "N",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "赞比亚",
                "enameAbbr": "ZMB",
                "ename": "Zambia"
            },
            {
                "id": "ZW",
                "code": "716",
                "zoneNumber": "+263",
                "highRiskFlag": "L",
                "ccontinent": "非洲",
                "econtinent": "AF",
                "cname": "津巴布韦",
                "enameAbbr": "ZWE",
                "ename": "Zimbabwe"
            }
        ],
        "map": {
            "PR": "波多黎各",
            "PS": "巴勒斯坦",
            "PT": "葡萄牙",
            "PW": "帕劳",
            "PY": "巴拉圭",
            "QA": "卡塔尔",
            "AD": "安道尔",
            "AE": "阿联酋",
            "AF": "阿富汗",
            "AG": "安提瓜和巴布达",
            "AI": "安圭拉",
            "AL": "阿尔巴尼亚",
            "AM": "亚美尼亚",
            "AO": "安哥拉",
            "AR": "阿根廷",
            "AT": "奥地利",
            "AU": "澳大利亚",
            "AW": "阿鲁巴",
            "AZ": "阿塞拜疆",
            "RO": "罗马尼亚",
            "BA": "波黑",
            "BB": "巴巴多斯",
            "RS": "塞尔维亚",
            "BD": "孟加拉国",
            "BE": "比利时",
            "RU": "俄罗斯",
            "BF": "布基纳法索",
            "BG": "保加利亚",
            "RW": "卢旺达",
            "BH": "巴林",
            "BI": "布隆迪",
            "BJ": "贝宁",
            "BM": "百慕大",
            "BN": "文莱",
            "BO": "玻利维亚",
            "SA": "沙特阿拉伯",
            "SB": "所罗门群岛",
            "BR": "巴西",
            "SC": "塞舌尔",
            "BS": "巴哈马",
            "SD": "苏丹",
            "BT": "不丹",
            "SE": "瑞典",
            "SG": "新加坡",
            "BW": "博茨瓦纳",
            "SI": "斯洛文尼亚",
            "BY": "白俄罗斯",
            "BZ": "伯利兹",
            "SK": "斯洛伐克",
            "SL": "塞拉利昂",
            "SM": "圣马力诺",
            "SN": "塞内加尔",
            "SO": "索马里",
            "CA": "加拿大",
            "SR": "苏里南",
            "SS": "南苏丹",
            "CD": "刚果民主共和国",
            "ST": "圣多美和普林西比",
            "CF": "中非共和国",
            "SV": "萨尔瓦多",
            "CH": "瑞士",
            "SY": "叙利亚",
            "SZ": "斯威士兰",
            "CK": "库克群岛",
            "CL": "智利",
            "CM": "喀麦隆",
            "CN": "中国",
            "CO": "哥伦比亚",
            "CR": "哥斯达黎加",
            "TD": "乍得",
            "CU": "古巴",
            "CV": "佛得角",
            "TG": "多哥",
            "TH": "泰国",
            "CY": "塞浦路斯",
            "TJ": "塔吉克斯坦",
            "CZ": "捷克",
            "TL": "东帝汶",
            "TM": "土库曼斯坦",
            "TN": "突尼斯",
            "TO": "汤加",
            "TR": "土耳其",
            "TT": "特立尼达和多巴哥",
            "DE": "德国",
            "TV": "图瓦卢",
            "TW": "中国台湾",
            "DJ": "吉布提",
            "TZ": "坦桑尼亚",
            "DK": "丹麦",
            "DM": "多米尼克",
            "DO": "多米尼加",
            "UA": "乌克兰",
            "UG": "乌干达",
            "DZ": "阿尔及利亚",
            "EC": "厄瓜多尔",
            "US": "美国",
            "EE": "爱沙尼亚",
            "EG": "埃及",
            "UY": "乌拉圭",
            "UZ": "乌兹别克斯坦",
            "VA": "梵蒂冈",
            "VC": "圣文森特和格林纳丁斯",
            "ES": "西班牙",
            "ET": "埃塞俄比亚",
            "VE": "委内瑞拉",
            "VG": "英属维尔京群岛",
            "VI": "美属维尔京群岛",
            "VN": "越南",
            "VU": "瓦努阿图",
            "FI": "芬兰",
            "FJ": "斐济",
            "FR": "法国",
            "GA": "加蓬",
            "GB": "英国",
            "WS": "萨摩亚",
            "GD": "格林纳达",
            "GE": "格鲁吉亚",
            "GF": "法属圭亚那",
            "GH": "加纳",
            "GI": "直布罗陀",
            "GL": "格陵兰",
            "GM": "冈比亚",
            "GR": "希腊",
            "GT": "危地马拉",
            "GW": "几内亚比绍",
            "GY": "圭亚那",
            "XK": "科索沃",
            "HK": "中国香港",
            "HN": "洪都拉斯",
            "HR": "克罗地亚",
            "HT": "海地",
            "YE": "也门",
            "HU": "匈牙利",
            "ID": "印度尼西亚",
            "IE": "爱尔兰",
            "IL": "以色列",
            "IN": "印度",
            "ZA": "南非",
            "IQ": "伊拉克",
            "IR": "伊朗",
            "IS": "冰岛",
            "IT": "意大利",
            "ZM": "赞比亚",
            "ZW": "津巴布韦",
            "JM": "牙买加",
            "JO": "约旦",
            "JP": "日本",
            "KE": "肯尼亚",
            "KG": "吉尔吉斯斯坦",
            "KH": "柬埔寨",
            "KI": "基里巴斯",
            "KM": "科摩罗",
            "KN": "圣基茨和尼维斯",
            "KP": "朝鲜",
            "KR": "韩国",
            "KW": "科威特",
            "KY": "开曼群岛",
            "KZ": "哈萨克斯坦",
            "LA": "老挝",
            "LB": "黎巴嫩",
            "LC": "圣卢西亚",
            "LI": "列支敦士登",
            "LK": "斯里兰卡",
            "LR": "利比里亚",
            "LS": "莱索托",
            "LT": "立陶宛",
            "LU": "卢森堡",
            "LV": "拉脱维亚",
            "LY": "利比亚",
            "MA": "摩洛哥",
            "MC": "摩纳哥",
            "MD": "摩尔多瓦",
            "ME": "黑山",
            "MG": "马达加斯加",
            "MH": "马绍尔群岛",
            "MK": "北马其顿",
            "ML": "马里",
            "MM": "缅甸",
            "MN": "蒙古",
            "MO": "中国澳门",
            "MR": "毛里塔尼亚",
            "MT": "马耳他",
            "MU": "毛里求斯",
            "MV": "马尔代夫",
            "MW": "马拉维",
            "MX": "墨西哥",
            "MY": "马来西亚",
            "MZ": "莫桑比克",
            "NA": "纳米比亚",
            "NE": "尼日尔",
            "NG": "尼日利亚",
            "NI": "尼加拉瓜",
            "NL": "荷兰",
            "NO": "挪威",
            "NP": "尼泊尔",
            "NR": "瑙鲁",
            "NU": "纽埃",
            "NZ": "新西兰",
            "OM": "阿曼",
            "PA": "巴拿马",
            "PE": "秘鲁",
            "PF": "波利尼西亚",
            "PG": "巴布亚新几内亚",
            "PH": "菲律宾",
            "PK": "巴基斯坦",
            "PL": "波兰"
        }
    }
}